import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Events from "../views/Events/Events.vue";
import RiverReports from "../views/RiverReports.vue";
import SignUp from "../components/signinform.vue";
import Account from "../views/Account.vue";
import UpdateRR from "../views/Admin/updateRiverReports.vue";
import AddEmployee from "../views/Admin/addEmployee.vue";
import EventPortal from "../views/Admin/EventPortal.vue";
import GuideTrips from "../views/GuideTrips.vue";
import Blog from "../views/Blog/Blog.vue";
import AddBlog from "../views/Admin/addBlog.vue";
import SingleBlog from "../views/Blog/singleBlog.vue";
import KidsCamp from "../views/Events/KidsCamp.vue";
import KidsCampSignUp from "../views/KidsCamp/KidsCampSignUp.vue";
import Schedule from "../views/schedule.vue";
import Handler from "../views/emailHandler.vue";
import Sylvandale from "../views/GuideTrips/Sylvandale.vue";
import Phantom from "../views/GuideTrips/PhantomCanyon.vue";
import Boxwood from "../views/GuideTrips/Boxwood.vue";
import SouthBoulderCreek from "../views/GuideTrips/SouthBoulderCreek.vue";
import HalfDay from "../views/GuideTrips/HalfDay.vue";
import FullDay from "../views/GuideTrips/FullDay.vue";
import Forgot from "../views/Forgot.vue";
import Policies from "../views/Policies.vue";
import SpecialtyTrips from "../views/GuideTrips/SpecialtyTrips.vue";
import Calendar from "../views/schedule.vue";
import TyingVideos from "../views/tyingVideos.vue";
import WhatToBring from "../views/GuideTrips/WhatToBring.vue";
import AddAnnouncements from "../views/Admin/addAnnouncements.vue";
import EventClassContainer from "../views/Events/EventClassContainer";
import EventActions from "../views/Admin/EventActions";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/Events",
		name: "Events",
		component: Events,
	},
	{
		path: "/Events/:id",
		name: "Events",
		component: Events,
	},
	{
		path: "/RiverReports",
		name: "RiverReports",
		component: RiverReports,
	},
	{
		path: "/RiverReports/:id",
		name: "RiverReports",
		component: RiverReports,
	},
	{
		path: "/SignUp",
		name: "SignUp",
		component: SignUp,
	},
	{
		path: "/Account",
		name: "Account",
		component: Account,
	},
	{
		path: "/UpdateRR",
		name: "UpdateRR",
		component: UpdateRR,
	},
	{
		path: "/AddEmployee",
		name: "AddEmployee",
		component: AddEmployee,
	},
	{
		path: "/EventPortal",
		name: "EventPortal",
		component: EventPortal,
	},
	{
		path: "/Classes",
		name: "Classes",
		component: Events,
	},
	{
		path: "/Classes/:id",
		name: "Classes",
		component: Events,
	},
	{
		path: "/GuideTrips",
		name: "GuideTrips",
		component: GuideTrips,
	},
	{
		path: "/Blog",
		name: "Blog",
		component: Blog,
	},
	{
		path: "/AddBlog",
		name: "AddBlog",
		component: AddBlog,
	},
	{
		path: "/Blog/:id",
		name: "SingleBlog",
		component: SingleBlog,
	},
	{
		path: "/Camp",
		name: "KidsCamp",
		component: KidsCamp,
	},
	{
		path: "/KidsCamp/:id/:date/:time",
		name: "KidsCampSignUp",
		component: KidsCampSignUp,
	},
	{
		path: "/schedule",
		name: "Schedule",
		component: Schedule,
	},
	{
		path: "/_/Handler",
		name: "Handler",
		component: Handler,
	},
	{
		path: "/Sylvandale",
		name: "Sylvandale",
		component: Sylvandale,
	},
	{
		path: "/Phantom",
		name: "Phantom",
		component: Phantom,
	},
	{
		path: "/Boxwood",
		name: "Boxwood",
		component: Boxwood,
	},
	{
		path: "/SBCPrivate",
		name: "SBCPrivate",
		component: SouthBoulderCreek,
	},
	{
		path: "/HalfDay",
		name: "HalfDay",
		component: HalfDay,
	},
	{
		path: "/FullDay",
		name: "FullDay",
		component: FullDay,
	},
	{
		path: "/Forgot",
		name: "Forgot",
		component: Forgot,
	},
	{
		path: "/Policies",
		name: "Policies",
		component: Policies,
	},
	{
		path: "/SpecialtyTrips",
		name: "SpecialtyTrips",
		component: SpecialtyTrips,
	},
	{
		path: "/Calendar",
		name: "Calendar",
		component: Calendar,
	},
	{
		path: "/TyingVideos",
		name: "TyingVideos",
		component: TyingVideos,
	},
	{
		path: "/WhatToBring",
		name: "WhatToBring",
		component: WhatToBring,
	},
	{
		path: "/AddAnnouncements",
		name: "AddAnnouncements",
		component: AddAnnouncements,
	},
	{
		path: "/Events/:id",
		name: "EventClassContainer",
		component: EventClassContainer,
	},
	{
		path: "/EventActions/:id",
		name: "EventActions",
		component: EventActions,
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
});

export default router;
